import { render, staticRenderFns } from "./PresetsTab.vue?vue&type=template&id=68ed40e3&scoped=true&"
import script from "./PresetsTab.vue?vue&type=script&lang=js&"
export * from "./PresetsTab.vue?vue&type=script&lang=js&"
import style0 from "./PresetsTab.vue?vue&type=style&index=0&id=68ed40e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed40e3",
  null
  
)

component.options.__file = "PresetsTab.vue"
export default component.exports